import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectErrors } from '../App/selectors';
import { appReset, clearErrors } from '../App/actions';
import { Button } from '../Controls';
import { Detail, Toast } from './styled';

const isProduction = process.env.NODE_ENV === 'production';

/** What went wrong, from the server's own message where it gave one ("Draw a card first."). */
export function errorMessage(error) {
  const data = error.response && error.response.data;

  if (data && typeof data === 'object' && data.message) {
    return data.message;
  }

  if (typeof data === 'string' && data) {
    return data;
  }

  return 'Something went wrong.';
}

const Errors = () => {
  const dispatch = useDispatch();
  const errors = useSelector(selectErrors);

  const onClear = useCallback(function () {
    dispatch(clearErrors());
    dispatch(appReset());
  }, [dispatch]);

  if (!errors.size) {
    return null;
  }

  return (
    <Toast role="alert">
      <div>
        {errors.map((error, i) => {
          const status = error.response ? `${error.response.status} ` : '';
          if (isProduction) {
            console.error(status + (error.message || ''));
          }
          return <p key={i}>
            {errorMessage(error)}
            {!isProduction && <Detail>{status}{error.message}</Detail>}
          </p>;
        })}
      </div>
      <Button onClick={onClear}>OK</Button>
    </Toast>
  );
};

export default Errors;
